import React, { useState } from 'react';
import Typography from '@mui/material/Typography';
import Switch from '@mui/material/Switch';
import { switchAssessmentSendRejectionEmail } from 'requests/EmailRequests';
import PreviewRejectionEmailButton from 'components/assessments_pages/asessment_settings_components/InstructionToCandidatesSection/components/PreviewRejectionEmailButton';
import { withStyles } from '@mui/styles';
import styles from './styles';

const CandidateRejection = (props) => {
    const { setSaving, audition, setAudition } = props;
    const { slug, sendRejectEmail } = audition;

    const [isSettingsActive, setIsSettingActive] = useState(sendRejectEmail);

    const handleChangeNotifyAboutReject = async (e) => {
        const { checked } = e.target;
        setSaving(true);
        setIsSettingActive(checked);
        await switchAssessmentSendRejectionEmail(slug);
        setAudition({ ...audition, sendRejectEmail: checked });
        setSaving(false);
    };

    return (
        <div className="u-dsp--distribute u-fw--wrap u-mrg--bx3 u-wdt--100p">
            <div className="u-mrg--bx2">
                <Typography variant="h5" className="u-mrg--bx1">Candidate Rejection</Typography>
                <div>Email candidate when rejecting?</div>
                <PreviewRejectionEmailButton audition={audition} />
            </div>
            <Switch
                checked={isSettingsActive}
                onChange={handleChangeNotifyAboutReject}
                value="reminder"
            />
        </div>
    );
};

export default withStyles(styles)(CandidateRejection);
